import { render } from "./task-board-modal.vue?vue&type=template&id=ebf505f8"
import script from "./task-board-modal.vue?vue&type=script&lang=js"
export * from "./task-board-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__